import { Link } from 'react-router-dom';
import { Button } from '@shared/components/ui/button';
import { Home, Search, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-md mx-auto text-center">
        <h1 className="text-9xl font-bold text-muted-foreground/20">404</h1>
        <h2 className="text-2xl font-semibold mt-4 mb-2">Pagina niet gevonden</h2>
        <p className="text-muted-foreground mb-8">
          De pagina die u zoekt bestaat niet of is verplaatst.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button variant="default" className="flex items-center gap-2">
              <Home className="h-4 w-4" />
              Naar homepage
            </Button>
          </Link>
          <Link to="/search">
            <Button variant="outline" className="flex items-center gap-2">
              <Search className="h-4 w-4" />
              Zoek jurisprudentie
            </Button>
          </Link>
        </div>
        
        <Button 
          variant="ghost" 
          onClick={() => window.history.back()}
          className="mt-8 flex items-center gap-2 mx-auto"
        >
          <ArrowLeft className="h-4 w-4" />
          Ga terug
        </Button>
      </div>
    </div>
  );
}